var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button-wrapper",staticStyle:{"min-width":"100%"},attrs:{"height":"auto","color":"primary","disabled":_vm.disabled,"outlined":"","rounded":""},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }